import telegram from './telegram.vue';
import vk from './vk.vue';
import art from './art.vue';
import science from './science.vue';
import social from './social.vue';
import sport from './sport.vue';
import tech from './tech.vue';
import tourism from './tourism.vue';


export default {
  telegram: { component: telegram },
  vk: { component: vk },
  art: { component: art },
  science: { component: science },
  social: { component: social },
  sport: { component: sport },
  tech: { component: tech },
  tourism: { component: tourism },
};
